import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
// News
import NewsView from "@/views/News/NewsView.vue";
import NewsInfo from "@/views/News/NewsInfo.vue";
// Projects
import ProjectsView from "@/views/Projects/ProjectsView.vue";
import ProjectInfo from "@/views/Projects/ProjectInfo.vue";
// team
import OurTeamVue from "@/views/OurTeam.vue";
// Login
import LoginView from "@/views/LoginView.vue";
// Register
import RegisterView from "@/views/RegisterView.vue";

// Admin Dashboard
import AdminHome from "@/views/AdminDashboard/AdminHome.vue";
// Admin users
import UsersView from "@/views/AdminDashboard/Users/UsersView.vue";
// Admin add user
import AddUserVue from "@/views/AdminDashboard/Users/AddUser.vue";
// Admin News
import AdminNews from "@/views/AdminDashboard/News/NewsView.vue";
// Admin add News
import AddNews from "@/views/AdminDashboard/News/AddNews.vue";
// Admin add news files
import AddFiles from "@/views/AdminDashboard/News/AddFiles.vue";
// Admin projects
import AdminProjects from "@/views/AdminDashboard/Projects/AdminProjects.vue";
// Admin add projects
import AddProject from "@/views/AdminDashboard/Projects/AddProject.vue";
// Admin edit Projects
import EditProject from "@/views/AdminDashboard/Projects/EditProject.vue";
// Admin Services
import ServicesViewVue from "@/views/AdminDashboard/Services/ServicesView.vue";
// Admin Add Service
import AddServiceVue from "@/views/AdminDashboard/Services/AddService.vue";
// Admin Types
import TypesViewVue from "@/views/AdminDashboard/Types/TypesView.vue";
// Admin Add type
import AddTypeVue from "@/views/AdminDashboard/Types/AddType.vue";
// Admin Plans
import PlansViewVue from "@/views/AdminDashboard/Plans/PlansView.vue";
// Admin Add plan
import AddPlanVue from "@/views/AdminDashboard/Plans/AddPlan.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  // News
  {
    path: "/news",
    name: "News",
    component: NewsView,
  },
  {
    path: "/news-info",
    name: "NewsInfo",
    component: NewsInfo,
  },
  // Projects
  {
    path: "/projects",
    name: "ProjectsView",
    component: ProjectsView,
  },
  {
    path: "/project-info",
    name: "ProjectInfo",
    component: ProjectInfo,
  },
  // tean
  {
    path: "/our-team",
    name: "OurTeam",
    component: OurTeamVue,
  },
  // login
  {
    path: "/login",
    name: "LoginView",
    component: LoginView,
  },
  // register
  {
    path: "/make-appointment",
    name: "RegisterView",
    component: RegisterView,
  },
  // Admin dashboard
  {
    path: "/admin-home",
    name: "AdminHome",
    component: AdminHome,
  },
  // Admin users
  {
    path: "/admin-users",
    name: "UsersView",
    component: UsersView,
  },
  // Admin users
  {
    path: "/admin-add-user",
    name: "AddUser",
    component: AddUserVue,
  },
  // Admin News
  {
    path: "/admin-news",
    name: "AdminNews",
    component: AdminNews,
  },
  // Admin add News
  {
    path: "/admin-add-news",
    name: "AddNews",
    component: AddNews,
  },
  // Admin add News files
  {
    path: "/admin-add-files",
    name: "AddFiles",
    component: AddFiles,
  },
  // Admin Projects
  {
    path: "/admin-projects",
    name: "AdminProjects",
    component: AdminProjects,
  },
  // Admin add Projects
  {
    path: "/admin-add-project",
    name: "AddProject",
    component: AddProject,
  },
  // Admin edit Projects
  {
    path: "/admin-edit-project",
    name: "EditProject",
    component: EditProject,
  },
  // Admin Services
  {
    path: "/admin-services",
    name: "ServicesView",
    component: ServicesViewVue,
  },
  // Admin add service
  {
    path: "/admin-add-services",
    name: "AddService",
    component: AddServiceVue,
  },
  // Admin Types
  {
    path: "/admin-types",
    name: "TypesView",
    component: TypesViewVue,
  },
  // Admin add Types
  {
    path: "/admin-add-types",
    name: "AddTypeView",
    component: AddTypeVue,
  },
  // Admin plans
  {
    path: "/admin-plans",
    name: "PlansView",
    component: PlansViewVue,
  },
  // Admin add plan
  {
    path: "/admin-add-plans",
    name: "AddPlan",
    component: AddPlanVue,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
